﻿import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import classes from "../maintainers.module.scss";
import { formatMilesDecimalNew, hasPermission, validRoles } from "@/services/Utils";

import { ReactComponent as PencilSvg } from "@/assets/images/desktop/editar.svg";
import { ReactComponent as RemoveSvg } from "@/assets/images/desktop/remove.svg";
import { ReactComponent as OutSvg } from "@/assets/images/desktop/out.svg";
import CustomTooltip from "@/components/desktop/tooltip/CustomTooltip";
import CustomBadge from "@/components/desktop/badge/CustomBadge.jsx";

const EstatesTableBody = ({ handleDelete, handleOut, permissions }) => {
	const navigate = useNavigate();

	const userRoles = JSON.parse(localStorage.getItem("roles"));
	const isAdmin = validRoles(userRoles, ["administrador"]);

	const { estates, categories } = useSelector((state) => state.maintainers_estates);
	const { customer } = useSelector((state) => state.auth.user);

	const getCategoryLabels = (categoryIds) => {
		if (!categoryIds || !categories || categories.length === 0) {
			return null;
		}

		const ids = categoryIds.split(",").map((id) => id.trim());
		return ids.map((id) => {
			const category = categories.find((cat) => String(cat.value) === String(id));
			const label = category ? category.label : id;

			return (
				<CustomBadge key={id} style={{ marginRight: "3px" }} variant="neutral">
					{label}
				</CustomBadge>
			);
		});
	};

	return (
		<tbody>
			{estates &&
				estates.map((item, i) => {
					return (
						<tr className={`${classes.table_tr}`} key={i}>
							<td className={`${classes.table_td} ${classes.first_td}`}>
								<div className={`${classes.table_div}  ${classes.first_div}`}>{i + 1}</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div}`}>{item.name}</div>
							</td>
							{!!customer.use_estates_parents && (
								<td className={`${classes.table_td} ${classes.first_td}`}>
									<div className={`${classes.table_div}`}>{item.estate_parent_name}</div>
								</td>
							)}
							{!customer.use_estates_parents && (
								<>
									<td className={`${classes.table_td}`}>
										<div className={`${classes.table_div}`} style={{ justifyContent: "center" }}>
											{item.hectares ? `${formatMilesDecimalNew(item.hectares)} ha` : ""}
										</div>
									</td>
									<td className={`${classes.table_td}`}>
										<div className={`${classes.table_div}`} style={{ justifyContent: "center" }}>
											{item.time_open}
										</div>
									</td>
									<td className={`${classes.table_td}`}>
										<div className={`${classes.table_div}`} style={{ justifyContent: "center" }}>
											{item.time_close}
										</div>
									</td>
								</>
							)}
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div}`}>{getCategoryLabels(item.categories_id)}</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.last_div}`}>
									{!!isAdmin && (
										<CustomTooltip
											text={<OutSvg className={classes.icon} style={{ fill: "#174982" }} onClick={() => handleOut(item)} />}
											description={"Sacar todos los productos de bodega"}
										/>
									)}

									{hasPermission("edit", permissions) && (
										<PencilSvg className={classes.icon} onClick={() => navigate("/configuracion/campos/editar/" + item.slug)} />
									)}
									{hasPermission("delete", permissions) && <RemoveSvg className={classes.icon} onClick={() => handleDelete(item)} />}
								</div>
							</td>
						</tr>
					);
				})}
		</tbody>
	);
};

export default EstatesTableBody;
